import React from "react";
import { Globe } from "lucide-react";
import { LANGS, translations } from "@/i18n/translations";
import { useT } from "@/i18n/LanguageContext";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

export default function LanguageSwitcher({ scrolled = false }) {
  const { lang, setLang, t } = useT();
  const current = translations[lang];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="language-switcher-trigger"
        aria-label={t.nav.langSwitcher}
        className={`inline-flex items-center gap-2 h-10 px-3 rounded-full text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-[#005BEA] focus:ring-offset-2 ${
          scrolled
            ? "text-slate-700 hover:bg-slate-100"
            : "text-white/85 hover:text-white hover:bg-white/10"
        }`}
      >
        <Globe className="w-4 h-4" strokeWidth={2.2} />
        <span className="font-semibold tracking-wide">{current.short}</span>
      </DropdownMenuTrigger>
      <DropdownMenuContent
        align="end"
        className="w-44 mt-2 bg-white border border-slate-200 rounded-xl shadow-[0_18px_50px_-15px_rgba(15,23,42,0.18)] p-1.5"
      >
        {LANGS.map((code) => {
          const meta = translations[code];
          const active = code === lang;
          return (
            <DropdownMenuItem
              key={code}
              data-testid={`language-option-${code}`}
              onSelect={() => setLang(code)}
              className={`cursor-pointer rounded-lg px-3 py-2.5 text-sm flex items-center justify-between gap-3 ${
                active
                  ? "bg-[#005BEA]/10 text-[#005BEA] font-semibold"
                  : "text-slate-700 hover:bg-slate-100"
              }`}
            >
              <span>{meta.label}</span>
              <span
                className={`text-[10px] tracking-[0.18em] uppercase font-bold ${
                  active ? "text-[#005BEA]" : "text-slate-400"
                }`}
              >
                {meta.short}
              </span>
            </DropdownMenuItem>
          );
        })}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
